import { Component, inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';

import { NotesAppStateService } from '@modules/notes/services/state.service';

import { ListState } from '@modules/notes/types/list-state';
import { Note } from '@modules/notes/types/note';
import { Notebook } from '@modules/notes/types/notebook';

import { FullFormBaseComponent } from '@modules/common/components/full-form-base/full-form-base.component';
import { AbstractMainViewComponent } from '@modules/common/components/main-view/main-view.component';
import { getStitchInstanceByStitchType } from '@modules/common/utils/stitch';
import { StitchType } from '@sharedlib/common/types/StitchType';

@Component({
  selector: 'app-notes-main-view',
  templateUrl: './notes-main-view.component.html',
  styleUrls: ['./notes-main-view.component.less'],
  standalone: false,
})
export class NotesMainViewComponent extends AbstractMainViewComponent<
  StitchType.NOTE | StitchType.NOTEBOOK,
  Note | Notebook,
  FullFormBaseComponent<StitchType.NOTE | StitchType.NOTEBOOK, Note | Notebook, Record<string, AbstractControl>>,
  ListState
> {
  protected override readonly stateService = inject(NotesAppStateService);

  asNote(item: Note | Notebook): Note {
    return item as Note;
  }

  asNotebook(item: Note | Notebook): Notebook {
    return item as Notebook;
  }

  protected handleNewNote(): void {
    this.openCreateModal(getStitchInstanceByStitchType(StitchType.NOTE));
  }

  protected handleNewNotebook(): void {
    this.openCreateModal(getStitchInstanceByStitchType(StitchType.NOTEBOOK));
  }
}
